import React from "react";
import {pageAuthorizedByPermission} from "../../fragments/PageAuthorization";
import {permissions} from "../../../global/Permissions";
import {useQuery} from "@apollo/client";
import {graphQLServices} from "../../../services/GraphQLServices";
import {Box, Breadcrumbs, CircularProgress, Typography} from "@mui/material";
import {AUTH_ANALYZE_CHANGES} from "../../../backend/authorization/AuthQueries";
import {deepClone, normalizeData} from "../../../libraries/util/Functions";
import {PentaSplit} from "../../../components/common/PentaSplit";
import {Link} from "react-router-dom";
import {DeployDisplay} from "../../../components/common/deploy/DeployDisplay";
import {translateFunction} from "../../../localization/TranslationService";
import {AuthDifferenceSet} from "../../../backend/authorization/models/AuthDifferenceSet";
import {AuthPolicy} from "../../../backend/authorization/models/AuthPolicy";
import {AuthPolicyUsage} from "../../../backend/authorization/models/AuthPolicyUsage";
import {openAuthPolicyDetailsFor} from "../policies/PolicyDetailsPage";
import {deletePolicy, deletePolicyUsage, putPolicy, putPolicyUsage} from "../Functions";
import {openAuthPolicyUsageDetailsFor} from "../policyusages/PolicyUsagesOverviewPage";

const translate = translateFunction();

export const AuthorizationDeployPage = pageAuthorizedByPermission(function () {
	const query = useQuery(AUTH_ANALYZE_CHANGES, {
		client: graphQLServices.authorizationClient,
		fetchPolicy: "no-cache"
	});
	
	if (query.error)
		throw query.error;
	
	if (query.loading)
		return <Box sx={{display: "flex", width: "100%", height: "100%"}}>
			<CircularProgress style={{margin: "auto"}}/>
		</Box>;
	
	const differenceSet: AuthDifferenceSet = normalizeData(deepClone(query.data.analyzeChanges));
	
	return <PentaSplit
		top={<Breadcrumbs style={{margin: "5px"}}>
			<Link style={{color: "inherit", textDecoration: "unset"}}
				to="/authorization">{translate("Authorization")}</Link>
			<Typography color="text.primary">{translate("Deploy")}</Typography>
		</Breadcrumbs>}
		center={<div style={{overflowY: "auto", height: "100%"}}>
			{differenceSet.policies.length === 0 && differenceSet.policyUsages.length === 0 && <div>No changes detected</div>}
			{differenceSet.policies.map((set, index) => {
				return <DeployDisplay<AuthPolicy>
					name={translate("Policy")}
					stages={differenceSet.stages}
					items={set}
					keyMapper={it => it.krn}
					key={`policy-${index}`}
					putItem={putPolicy}
					deleteItem={deletePolicy}
					openItemDetails={openAuthPolicyDetailsFor}
					allowBackwardsSync
				/>;
			})}
			{differenceSet.policyUsages.map((set, index) => {
				return <DeployDisplay<AuthPolicyUsage>
					name={translate("Policy Usage")}
					stages={differenceSet.stages}
					items={set}
					keyMapper={it => it.krn}
					key={`policy-usage-${index}`}
					putItem={putPolicyUsage}
					deleteItem={deletePolicyUsage}
					openItemDetails={openAuthPolicyUsageDetailsFor}
					allowBackwardsSync
				/>;
			})}
		</div>}
	/>;
}, [permissions.authorizationPutPolicy, permissions.authorizationPutPolicyUsage]);
